import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface IBreadcrumb {
  label: string;
  url: string;
}

export type Breadcrumb = IBreadcrumb;

@Injectable({ providedIn: 'root' })
export class BreadcrumbsService {

  private breadcrumbSubject = new BehaviorSubject<string | null>(null);
  breadcrumb$ = this.breadcrumbSubject.asObservable();

  private breadcrumbsListSubject = new BehaviorSubject<IBreadcrumb[] | null>(null);
  breadcrumbs$ = this.breadcrumbsListSubject.asObservable();

  constructor() {
    (window as any).csBreadcrumbsService = this;
  }

  setDynamicLabel(label: string) {
    this.breadcrumbSubject.next(label);
  }

  setBreadcrumbs(breadcrumbs: IBreadcrumb[]) {
    this.breadcrumbsListSubject.next(breadcrumbs);
  }

  clearBreadcrumbs() {
    this.breadcrumbsListSubject.next(null);
    this.breadcrumbSubject.next(null);
  }

}
